import request from '@/utils/request'

//查询首页头部导航栏所有栏目
export function queryAllChannel() {	
	return request.post('/front/content/queryAllChannel')
}

//查询首页轮播图列表
export function queryCarouselByStatus(status) {	
	return request.post('/front/content/queryCarouselByStatus?status='+status)
}